export default __webpack_public_path__ + "static/media/photo11.87e202cb.jpg";